// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3uJp-","buttons":"RemoveExpirationActionButtons_buttons__2PJQR"};